module.exports = __webpack_public_path__ + "static/media/lock.de189c8a.svg";